import { Nav } from 'react-bootstrap';
import styled from 'styled-components';
import { TSize } from './NavBadge';

// One of a row of choices across the top of a page: a pill, or a tab with a line under it, as the operator's theme has them.
// The menu's categories and the site select modal's channels are both these, so they look alike.
const NavPill = styled(Nav.Item)<{ size: TSize; variant: string }>`
    display: flex;
    margin: 0 24px;

    &:first-child { margin-left: 0; }

    button {
        border: none;
        background-color: transparent;

        cursor: pointer;
        text-decoration: none;
        display: flex;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                supported by Chrome, Edge, Opera and Firefox */
        align-items: center;

        h3 {
            display: inline;
            margin: 0;
            padding: 0;
            font-size: 16px;
            line-height: 16px;
        }

        .count {
            font-size: 12px;
            margin-left: 4px;
        }
    }

    ${(props) => (props.variant === 'pill' && `
        margin: 8px;
        border-radius: var(--radius_m);
        text-overflow: ellipsis;

        button {
            border: var(--ui_nav_channels_border);
            border-color: transparent;
            border-radius: var(--radius_m);
            padding: 8px 16px;
            text-overflow: ellipsis;
            transition: background-color 0.15s ease-in-out;

            &:hover, &:focus {
                border: var(--ui_nav_channels_border);
            }

            h3 {
                color: var(--ui_nav_channels_pill_inactive_label);
            }

            &:hover {
                background: var(--bg-grey);
            }

            &:focus {
                outline: none;
                box-shadow: 0px 0px 0px 4px var(--ui_nav_channels);
            }
        }

        &.active {
            button {
                background-color: var(--ui_nav_channels);
                border: var(--ui_nav_channels_border);

                h3 {
                    color: var(--ui_nav_channels_pill_label);
                }
            }
        }

        @media screen and (max-width: 767px) {
            margin: 10px 0 10px 8px;
            &:first-child {
                margin-left: 0;
            }
        }
        `)}

    ${(props) => (props.variant === 'underline' && `
        transition: border-color 0.2s ease-in-out;
        position: relative;
        height: 56px;
        margin: 0 16px;
        border-bottom: var(--ui_nav_channels_underline);
        border-bottom-color: transparent;

        h3 {
            color: var(--ui_nav_channels_underline_inactive_label);
        }

        button {
            padding: 0;
        }

        &:not(.active):hover {
            border-bottom: var(--ui_nav_channels_underline);
        }

        &.active {
            margin-bottom: 0;
            border-bottom: var(--ui_nav_channels_underline);

            h3 {
                color: var(--ui_nav_channels_underline_label);
            }
        }

        a {
            border-radius: 0;
            padding-left: 0;
            padding-right: 0;
        }

        &:hover {
            background: var(--bg-grey);
        }

        @media screen and (max-width: 767px) {
            margin: 0 16px;
        }
    `)}
`;

export default NavPill;
